<template>
    <div>
        <h3 class="pb-3 pt-4 text-base font-bold text-gray-700">{{ $t('investment_process.broker') }}</h3>
        <BaseInputText
            id="broker_number"
            v-model="brokerNumber"
            name="broker_number"
            :label="$t('investment_process.broker_id')"
            :label-font-bold="true"
            :required="broker?.broker_field_required" />

        <div class="relative flex items-start pt-4">
            <div class="flex h-6 items-center">
                <input
                    id="broker_disclaimer"
                    v-model="brokerDisclaimer"
                    aria-describedby="broker_disclaimer-description"
                    name="broker_disclaimer"
                    type="checkbox"
                    :required="broker?.broker_field_required"
                    class="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary" />
            </div>
            <div class="ml-3 text-sm leading-6">
                <label for="broker_disclaimer" class="font-semibold text-gray-900">{{
                    broker?.broker_disclaimer
                }}</label>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { getCampaignData } from '../../../utilities/investment-process/useCampaign'
import { useInvestmentProcessDataState } from '../../../utilities/investment-process/useInvestmentProcess'
import BaseInputText from '../../base/BaseInputText.vue'

const { broker } = getCampaignData().asset_data
const { brokerNumber, brokerDisclaimer } = storeToRefs(useInvestmentProcessDataState())
</script>

<style scoped></style>
